// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import ticketsReducer from './slices/TicketSlice';
import userReducer from './slices/userSlice';
import { authErrorMiddleware } from "./Middle/middleware/authErrorMiddleware";


const store = configureStore({
  reducer: {
    user: userReducer,
    tickets: ticketsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authErrorMiddleware),
});
export default store;
